import React, { useEffect} from 'react';
import PropTypes from 'prop-types';

import Media from 'reactstrap/lib/Media';
import Button from 'reactstrap/lib/Button';

import { useTranslation } from 'react-i18next';

import CustomModal from '../../../../Components/Components/Modal';
import { isMobileDevice } from '../../../../../../../utils/deviceUtils';
import { setUserScreenViewNew } from '../../../../../../../actions/member';
import { connect } from 'react-redux';
import { getTabLabelById, MENU_NAVIGATION, SCREENS } from '../../../../../../../constants/constants';

const StatisticsInfo = React.memo(({ toggleStatisticsInfo, toggleStatisticsModal, setScreenViewNew }) => {
  const { t } = useTranslation('common');

  useEffect(() => {
    if (toggleStatisticsInfo) {
      setScreenViewNew(SCREENS.MY_INFO.STATISTICS_INFO);
    }
  }, [toggleStatisticsInfo]);

  return (
    <CustomModal
      isOpen={toggleStatisticsInfo}
      toggle={toggleStatisticsModal}
      size="md"
      title={t('myInfo.statisticsInfo')}
      addClassName={(isMobileDevice()) && `my-info-ratings-modal-mobile-wrapper`}
      disableFlex
      footerClose
      body={(
        <div className="my-info-ratings-description">
          <div className="mb-2">
            <div className="my-info-ratings-description-title">
              {t('myInfo.statisticsInfoTitle1')}
            </div>
          </div>
          <div className="mb-2">
            <div className="my-info-ratings-description-title">
              {t('myInfo.statisticsInfoTitle2')}
            </div>
          </div>
          <div className="mb-2">
            <div className="my-info-ratings-description-title">
              {t('myInfo.statisticsInfoTitle3')}
            </div>
          </div>
          <div className="mb-2">
            <div className="my-info-ratings-description-title">
              {t('myInfo.statisticsInfoTitle4')}
            </div>
          </div>
          <div className="mb-2">
            <div className="my-info-ratings-description-title">
              {t('myInfo.statisticsInfoTitle5')}
            </div>
          </div>
          <div className="mb-2">
            <div className="my-info-ratings-description-title">
              {t('myInfo.statisticsInfoTitle6')}
            </div>
          </div>
          <div className="mb-2">
            <div className="my-info-ratings-description-title">
              {t('myInfo.statisticsInfoTitle7')}
            </div>
          </div>
        </div>
      )}
      footer={(
        <Button color="secondary" onClick={toggleStatisticsModal}>
          {t('common.close')}
        </Button>
      )}
    />
  );
});

const mapDispatchToProps = {
  setScreenViewNew: setUserScreenViewNew,
};

export default connect(null, mapDispatchToProps)(StatisticsInfo);
